import { DocumentNode, gql } from '@apollo/client';
import { Button, ButtonProps, useDisclosure } from '@chakra-ui/react';
import dayjs from 'dayjs';
import * as React from 'react';

import { ModalToJoinExternalEvent } from '@/components/ModalToJoinExternalEvent';
import { VenueFragment } from '@/fragments/venue-fragment';

import { ViewSimpleEvent_EventFragment } from './graphql-types/ViewSimpleEvent_EventFragment';

export const ViewSimpleEventButton: React.FC<
  ButtonProps & {
    event: ViewSimpleEvent_EventFragment;
    isJoiningWithSpecialPermissions: boolean;
  }
> & { eventFragment: DocumentNode } = ({
  event,
  children,
  isJoiningWithSpecialPermissions,
  ...props
}) => {
 
  const externalModal = useDisclosure();
  if (event.__typename !== 'SimpleEventV2') {
    return null;
  }

  return (
    <>
      <Button onClick={externalModal.onOpen} {...props}>
        {children ? children : 'Join Now'}
      </Button>
      <ModalToJoinExternalEvent
        isJoiningWithSpecialPermissions={isJoiningWithSpecialPermissions}
        isFuture={dayjs().isBefore(event.startDate)}
        isPast={dayjs().isAfter(event.endDate)}
        isOpen={externalModal.isOpen}
        onClose={externalModal.onClose}
        simpleEventOrConferenceId={event._id}
        venue={event.venue}
        isCurrentUserSpeaker={event.isCurrentUserSpeaker}
        meta={{
          type: 'simple_event',
          eventId: event._id,
          name: event.name,
        }}
        hasCanonicalVideo={!!event.hasCanonicalVideo}
        isAgoraMeet={event.venue?.online?.__typename === 'EventVenue_TradewingPlatform' && event.venue.online.stream?.__typename === 'EventVenue_TradewingPlatform_Stream_Agora_Video_Call'}
        meetId={(event.venue?.online?.__typename === 'EventVenue_TradewingPlatform' ? event.venue.online.agoraMeetId : '') ?? ''}
      />
    </>
  );
};

ViewSimpleEventButton.eventFragment = gql`
  fragment ViewSimpleEvent_EventFragment on EventV2 {
    _id
    name
    startDate
    endDate
    ... on SimpleEventV2 {
      hasCanonicalVideo
      isCurrentUserSpeaker
      venue {
        ...VenueFragment
      }
    }
  }
  ${VenueFragment}
`;
